import type { IInjector, IInjectorModule } from '@paperbits/common/injection';
import { ReplyCardViewModel } from './ko/replyCardViewModel';
import { NullBackgroundProvider } from './bg/nullBackgroundProvider';
import { ReplyCardHTMLElement } from './ko/runtime/reply-card-runtime';


export class ReplyCardRuntimeModule implements IInjectorModule {
    public register(injector: IInjector): void {
        customElements.define('reply-card-runtime', ReplyCardHTMLElement);

        injector.bind('replyCard', ReplyCardViewModel);
        injector.bindSingleton('backgroundProvider', NullBackgroundProvider);
    }
}